import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import classNames from 'classnames'

import styles from './round-icon.css'

function RoundIcon({ src, alt, disabled }) {
  return (
    <ReactSVG
      alt={alt}
      src={src}
      beforeInjection={(svg) => {
        svg.setAttribute(
          'class',
          classNames(styles.roundIcon, { [styles.disabled]: disabled })
        )
      }}
    />
  )
}

RoundIcon.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  disabled: PropTypes.bool
}

RoundIcon.defaultProps = {
  src: ''
}

export default RoundIcon
